function Line(el, handler) {
    this.el = el;
    this.handler = handler;
    this.id = el.getAttribute('id');
    this.pos1 = null;
    this.pos2 = null;

    this.strokeDashoffset = 0;
    this.pathLength = 0;
    this.pathStep = 0;
    this.dir = true;
    this.strokeWait = 0;
    this.drawed = false;
    this.hidden = true;
}

Line.prototype.init = function() {
    this.el.setAttribute('stroke', 'black');
}

Line.prototype.reverse = function() {
    this.setPositions(this.getPos2(), this.getPos1());
}

Line.prototype.setPositions = function(pos1 = new Position(), pos2 = new Position()) {
    this.pos1 = pos1;
    this.pos2 = pos2;

}


Line.prototype.applyPosition = function() {
    this.el.setAttribute('x1', this.pos1.getX());
    this.el.setAttribute('y1', this.pos1.getY());
    this.el.setAttribute('x2', this.pos2.getX());
    this.el.setAttribute('y2', this.pos2.getY());
}

Line.prototype.getPos1 = function() {return this.pos1;}
Line.prototype.getPos2 = function() {return this.pos2;}



Line.prototype.drawStroke = function() {
    if(this.hidden) {
        this.show();
    }
    if(!this.drawed) {
        this.strokeWait--;
        if(this.strokeWait <= 0) {
            if(this.strokeDashoffset * this.dir > 0) {
                this.strokeDashoffset -= this.pathStep * this.dir;
                if(this.strokeDashoffset * this.dir < 0) {
                    this.strokeDashoffset = 0;
                    this.drawed = true;
                }
                this.el.style.strokeDashoffset = this.strokeDashoffset;
            }
        }
    }
}

Line.prototype.showLine = function() {
    this.stroke('#000000');
    this.el.style.strokeDasharray = 800;
    this.el.style.strokeDashoffset = 0;
    this.applyPosition();

}

Line.prototype.hasPoint = function(point = new Point()) {
    if(point.getPos()) {
        if(point.getPos().equals(this.getPos1())) {
            return true;
        } else {
            if(point.getPos().equals(this.getPos2())) {
                this.reverse();
                return true;
            }
        }
    }
    return false;
}

Line.prototype.equals = function(line = new Line()) {
    // return line.getPos1().equals(this.getPos1()) && line.getPos2().equals(this.getPos2());
    return line.id === this.id;
}


Line.prototype.isBefore = function(line = new Line()) {
    if(this.getPos2().equals(line.getPos1())) {
        return true;
    } else if(this.getPos2().equals(line.getPos2())) {
        line.reverse();
        return true;
    }
    return false;

}

Line.prototype.toString = function() {
    return this.id + ': {pos1: ' + this.getPos1().toString() + ' - pos2: ' + this.getPos2().toString() + '}';
}

Line.prototype.stroke = function(hexaColor) {
    this.el.setAttribute('stroke', hexaColor);
}
//Anim fn
Line.prototype.prepare = function (speed=1) {
    this.drawed = false;
    this.dir = this.pos2.animated ? -1 : 1;
    this.pathLength = 800;
    this.strokeDashoffset = this.dir * this.pathLength;
    this.pathStep = this.pathLength * 0.015 * speed;
    // this.strokeWait = Math.floor(this.pathLength / this.pathStep);
    this.strokeWait =0;
    this.el.style.strokeDasharray = this.pathLength;
    this.el.style.strokeDashoffset = this.strokeDashoffset;
}

Line.prototype.hide = function() {
    // this.el.style.opacity = 0;
    this.el.classList.add('transp');
    this.hidden = true;
}

Line.prototype.show = function() {
    // this.el.style.opacity = 1;
    this.el.classList.remove('transp')
    this.hidden = false;
}

Line.prototype.animate = function() {
    this.drawStroke();
    this.applyPosition();
}

Line.prototype.stop = function() {
    this.hide();
    setTimeout(()=>{
        this.prepare();
    }, 400);
}
export default Line;
